module.exports = __webpack_public_path__ + "img/popularize11.4faccdd3.png";